module.exports = __webpack_public_path__ + "img/84821df.png";